module.exports = __webpack_public_path__ + "static/media/CTM Data Hub White.2d78efb9.svg";